import CryptoJS from "crypto-js";

export const PrivateKey = "cvLYplk6V0eefLzGePDdGw==";
export const API_USER_NAME = "PMS";
export const API_PASSWORD = "/EnfaRzwnDk+6jHohJFzYg==";

const parseKeyAndIv = (secretKey) => {
  let keyStr = secretKey || "";
  if (keyStr.length < 16) {
    keyStr = keyStr.padEnd(16, "\0");
  } else if (keyStr.length > 16) {
    keyStr = keyStr.slice(0, 16);
  }
  const key = CryptoJS.enc.Utf8.parse(keyStr);
  return { key, iv: key };
};

export const AesEncrypt = (text, secretKey = PrivateKey) => {
  const { key, iv } = parseKeyAndIv(secretKey);
  const encrypted = CryptoJS.AES.encrypt(text, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
};

export const AesDecrypt = (encryptedBase64, secretKey = PrivateKey) => {
  const { key, iv } = parseKeyAndIv(secretKey);
  const decrypted = CryptoJS.AES.decrypt(encryptedBase64, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
};

export const getDDMMYYYY = () => {
  const d = new Date();
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}${mm}${yyyy}`;
};

export const wrapEncryptedPayload = (innerPayload = {}) => {
  const innerEncrypted = AesEncrypt(JSON.stringify(innerPayload || {}), PrivateKey);
  const outerPayload = {
    UserId: API_USER_NAME,
    Password: API_PASSWORD,
    IPAddress: "127.0.0.1",
    MACAddress: "127.0.0.1",
    Data: innerEncrypted,
  };
  const dynamicKey = "PMS" + getDDMMYYYY();
  const outerEncrypted = AesEncrypt(JSON.stringify(outerPayload), dynamicKey);
  return { Input: outerEncrypted };
};
